const BASE_URL = 'https://api.dev.umb-360.com/api';
const URL = 'https://api.dev.umb-360.com';
export default {
    BASE_URL,
    URL
}
